module.exports = __webpack_public_path__ + "img/Two_Women_Macbook_Agent_Insights.7990f1a1.jpg";